// @flow
import { hasParam } from 'utils/url';
import queryString from 'query-string';

export const isDuplicateHeroSearchError = (errorDescription: string): boolean =>
  errorDescription.includes('already exists') ||
  errorDescription.includes('ya existe');

// Detects search on a page with a "search" query param
export const detectSearch = (search: string): boolean =>
  Boolean(
    !!queryString.parse(search).searchMode &&
      (!!queryString.parse(search).q ||
        hasParam(search, 'q') ||
        !!queryString.parse(search).pq ||
        hasParam(search, 'pq') ||
        !!queryString.parse(search).sort)
  );
